import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import Modal from 'react-modal'
import { TREATMENT } from '../services/routes'
import { AuthContext } from '../contexts/auth'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { Footer } from '../components/Footer'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        minWidth: '500px',
        bottom: 'auto',
        marginRight: '-50%',
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
    },
};

const Treatments = () => {

    const [treatments, setTreatments] = useState([])
    const [details, setDetails] = useState()
    const [textSearch, setTextSearch] = useState('')

    const [modalIsOpen, setIsOpen] = useState(false);
    const [showPostModal, setShowPostModal] = useState(false)
    const [showModalDelete, setShowModalDelete] = useState(false)

    const token = localStorage.getItem('token')

    const getTreatments = () => {
        axios(TREATMENT.GETALL, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(json => {
                console.log("treatment", json.data)
                setTreatments(json.data)
            })
    }

    const togglePostModal = (item) => {
        setIsOpen(!modalIsOpen);
        let date = new Date(item.date)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()
        item.dataAtendimento = `${day}/${month}/${year}`
        setDetails(item)
        setShowPostModal(!showPostModal)
    }

    const toggleModalDelete = (item) => {
        setIsOpen(!modalIsOpen)
        setDetails(item)
        setShowModalDelete(!showModalDelete)
    }

    const deleteTreatment = async (id) => {
        try {
            await axios.delete(`${TREATMENT.REMOVE.replace(/:id/gi, id)}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                })
            toast.success('Atendimento deletado!')
            getTreatments()
        }
        catch (err) {
            console.log(err)
        }
    }

    const formatDate = item => {
        let date = new Date(item)
        let day = date.getDate() + 1 < 10 ? `0${date.getDate() + 1}` : date.getDate() + 1
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
        let year = date.getFullYear()

        return `${day}/${month}/${year}`
    }

    useEffect(() => {

        getTreatments()

    }, [])

    return (
        <div id="page-top" className="sidebar-toggled">
            <Helmet>
                <title>Atendimentos - Coluço System</title>
            </Helmet>
            <div id="wrapper">

                {showPostModal && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={togglePostModal}
                    style={customStyles}
                    contentLabel="Modal de Atendimento"
                >
                    <button className="btn btn-danger float-right" onClick={togglePostModal}>Fechar</button>
                    <h2 className="mb-4">Informações do Atendimento</h2>

                    <b>Nome do Paciente:</b> {details.patient.name} {details.patient?.lastname} <br />
                    <b>Data de Atendimento:</b> {details.dataAtendimento} <br />
                    <b>Procedimento:</b> {details.procedure} <br />
                    <b>Honorário:</b> {details.fee} <br />
                    <b>Forma de Pagamento:</b> {details.formOfPayment} <br />
                    <b>Empresa:</b> {details.company} <br />
                    <b>CID:</b> {details.cid} <br />
                    <b>Anotação Médica:</b> <br />
                    {details.annotation} <br />
                    <b>Relatório Médico:</b>  <br />
                    {details.report} <br />
                    <b>Médico:</b> {details.doctor} <br />
                </Modal>}

                {showModalDelete && <Modal
                    ariaHideApp={false}
                    isOpen={modalIsOpen}
                    onRequestClose={toggleModalDelete}
                    style={customStyles}
                    contentLabel="Modal de Deletar atendimento"
                >
                    <button className="btn btn-danger float-right" onClick={toggleModalDelete}>X</button>
                    <h2 className="mb-4">Deletar atendimento</h2>

                    <h5 className="align-center">Tem certeza que quer excluir este atendimento?</h5>

                    <div className="d-flex mt-5 mb-4 justify-content-center">
                        {console.log(details)}
                        <button className="me-3 btn btn-danger" onClick={async () => {
                            await deleteTreatment(details._id)
                            toggleModalDelete()
                        }}>Excluir</button>
                        <button className="btn btn-primary" onClick={toggleModalDelete}>Fechar</button>
                    </div>

                </Modal>}

                <Header active="treatments" />

                <div id="content-wrapper" className="d-flex flex-column">

                    <div id="content">

                        <Navbar />

                        <div className="container-fluid">

                            <h1 className="h3 mb-2 text-gray-800">Atendimentos</h1>

                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Lista de atendimentos</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6" />
                                            <div className="col-sm-12 col-md-6">
                                                <div className="dataTables_filter text-right mb-2">
                                                    <input type="search" onChange={e => setTextSearch(e.target.value)} className="form-control" placeholder="Digite o nome do paciente ou CPF" />
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th>Nome do Paciente</th>
                                                    <th>Tipo de Atendimento</th>
                                                    <th>Data</th>
                                                    <th>Médico</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {treatments.filter(item => {
                                                    if (textSearch === '') {
                                                        return item
                                                    }
                                                    else if (item.patient.name.toLowerCase().includes(textSearch.toLowerCase()) || item.patient.cpf.toLowerCase().includes(textSearch.toLowerCase())) {
                                                        return item
                                                    }
                                                }).map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{`${item.patient.name} ${item.patient.lastname}`}</td>
                                                            <td>{item.procedure}</td>
                                                            <td>{formatDate(item.date)}</td>
                                                            <td>{item.doctor}</td>
                                                            <td>
                                                                <button title="Detalhes" className="btn btn-secondary me-1" onClick={() => togglePostModal(item)}><i className="fas fa-info fa-fw"></i></button>
                                                                <Link title="Editar" className="btn btn-success me-1" to={`/treatments/edit/${item._id}`}><i className="fas fa-pen fa-fw "></i></Link>
                                                                <button title="Excluir" className="btn btn-danger" onClick={() => toggleModalDelete(item)}><i className="fas fa-trash fa-fw"></i></button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                        </table>
                                    </div>
                                    {treatments.length <= 0 ?
                                        <div className="d-flex justify-content-center">
                                            <h6 className="">Não há atendimentos cadastrados</h6>
                                        </div>
                                        :
                                        ''
                                    }
                                </div>
                            </div>

                        </div>

                    </div>

                    <Footer />

                </div>

            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
        </div>
    )
}

export default Treatments
